module.exports = __webpack_public_path__ + "img/REWARD03.e4779fd6.png";